import { LEGACY_EVENTS } from '../../config/googleAnalyticsLegacyConfig';
import { MESSAGE_TYPE } from '../../constants/MessageTypes';
import { calculateMessageMediaURL } from '../../helper/mediaHelper';
import { calculateVideoUrl, getVideoThumbnailUrl } from '../../helper/videoHelper';
import { trackGALegacyEvent } from '../googleAnalytics/googleAnalyticsThunks';
import {
  getMessage,
  getMessageBody,
  getMessageMediaRelativePath,
  getMessageType,
  getVideoTitle,
} from '../messages/messageSelector';

export const openAsMailToEmail =
  ({ subject, body }) =>
  async (_dispatch, _getState, { _gccApiClient }) => {
    const bodyWithLinks = body;

    // for line breaks and proper formatting
    const encodedBody = encodeURIComponent(bodyWithLinks);
    const encodedSubject = encodeURIComponent(subject);
    window.location.href = `mailto:?subject=${encodedSubject}&body=${encodedBody}`;
  };

export const openAsEmlEmail =
  ({ messageIds }) =>
  async (dispatch, getState, { gccApiClient }) => {
    dispatch(trackGALegacyEvent(LEGACY_EVENTS.MESSAGE_FORWARD_EMAIL()));

    // NOTE: This solution aims at MS Outlook and might not work with other email clients.
    const emlContent = await generateEmlContent({
      messageIds,
      gccApiClient,
      getState,
    });

    const data = new Blob([emlContent], { type: 'text/plain' });

    const textFile = window.URL.createObjectURL(data);

    const link = document.createElement('a');
    link.href = textFile;
    link.download = 'beem.eml';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(textFile);
  };

const generateEmlContent = async ({ messageIds, getState }) => {
  // EML Headers should be empty
  let emlContent = 'To:\n';
  emlContent += 'Subject:\n';
  emlContent += 'X-Unsent: 1\n';
  emlContent += 'Content-Type: text/html; charset=utf-8\n\n';

  // EML Content (HTML)

  let htmlBody = '';
  for (const messageId of messageIds) {
    const type = getMessageType(messageId)(getState());
    const body = getMessageBody(messageId)(getState());
    const mediaRelativePath = getMessageMediaRelativePath(messageId)(getState());
    const message = getMessage(messageId)(getState());

    switch (type) {
      case MESSAGE_TYPE.MEDIA:
      case MESSAGE_TYPE.MEDIA_FROM_MAIL: {
        const mediaUrl = calculateMessageMediaURL(mediaRelativePath);
        htmlBody += `<p><img src="${mediaUrl}" style="max-width:600px;max-height: 600px;object-fit: contain;"></p>`;
        break;
      }
      case MESSAGE_TYPE.VIDEO: {
        const videoTitle = getVideoTitle(messageId)(getState());
        const { videoPlaybackId } = message;
        const videoThumbnailUrl = getVideoThumbnailUrl(videoPlaybackId);
        const videoUrl = calculateVideoUrl(videoPlaybackId);
        htmlBody += `<p><a href=${videoUrl}>${videoTitle}</a></p>`;
        htmlBody += `<p><img src="${videoThumbnailUrl}" style="max-width:600px;max-height: 600px;object-fit: contain;"></p>`;
        break;
      }
      default: {
        htmlBody += `<p>${body}</p>`;
        break;
      }
    }
  }

  emlContent += '<!DOCTYPE html><html><head></head><body>';
  emlContent += htmlBody;
  emlContent += '</body></html>';

  return emlContent;
};
